module.exports = __webpack_public_path__ + "static/media/350xl.71bfff1c.png";